module.exports = __webpack_public_path__ + "img/icon-info-light.41cdf785.svg";